import Icon from "@mui/icons-material/HowToReg";

import RelayAccessRequestCreate from "./RelayAccessRequestCreate";
import RelayAccessRequestEdit from "./RelayAccessRequestEdit";
import RelayAccessRequestsList from "./RelayAccessRequestsList";
import RelayAccessRequestShow from "./show";

export default {
  list: RelayAccessRequestsList,
  create: RelayAccessRequestCreate,
  edit: RelayAccessRequestEdit,
  show: RelayAccessRequestShow,
  icon: Icon,
  label: "Relay Access Requests",
  options: { label: "Relay Access Requests" },
  name: "relay-access-requests",
};
